var FontWeight;
(function (FontWeight) {
    FontWeight["NORMAL"] = "NORMAL";
    FontWeight["MEDIUM"] = "MEDIUM";
    FontWeight["SEMIBOLD"] = "SEMIBOLD";
})(FontWeight || (FontWeight = {}));
const FontWeightToStyles = {
    [FontWeight.NORMAL]: 'font-normal',
    [FontWeight.MEDIUM]: 'font-medium',
    [FontWeight.SEMIBOLD]: 'font-semibold',
};

export { FontWeight, FontWeightToStyles };
//# sourceMappingURL=font.js.map
